<template>
	<PageTitleComponent>Survey Analyser</PageTitleComponent>

	<section class="band">
		<RisposeComponent
			:agent-id="'ag_rv1z63629cer'"
			ref="agent"
			@loaded="loading = false"
		></RisposeComponent>

		<LoadingComponent
			:loading="loading"
			:outer-border="true"
		/>
	</section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import LoadingComponent from '@/components/shared/LoadingComponent.vue';
import RisposeComponent from '@/components/RisposeComponent.vue';
import PageTitleComponent from '@/components/shared/PageTitleComponent.vue';

export default defineComponent({
	components: { LoadingComponent, RisposeComponent, PageTitleComponent },
	data() {
		return {
			loading: true,
		};
	},
});
</script>
